import { createApiSlice } from "@common";
import {
  CRUD_OPPORTUNITY_SOURCE,
  GET_OPPORTUNITY_SOURCE_BY_OPPORTUNITY_ID,
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addOpportunitySource",
    method: "post",
    url: CRUD_OPPORTUNITY_SOURCE,
    stateKey: "message",
  },
  {
    name: "getOpportunitySourceByOpportunityId",
    method: "get",
    url: GET_OPPORTUNITY_SOURCE_BY_OPPORTUNITY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "opportunitySource",
  apiConfig,
  customReducers
);
const opportunitySourceSlice = slice;

export default opportunitySourceSlice.reducer;

export const {
  addOpportunitySource,
  getOpportunitySourceByOpportunityId,
} = thunks;

export const { setAdditionalData, rowSelect } = actions;
